<template>
  <Dialog
    v-model="dialogVisible"
    title="Edit Allergies"
    dialog-type="primary"
    dialog-size="small"
    header-icon-width="28px"
    header-icon-height="17px"
    :close-on-overlay="false"
    @close="closeDialog"
  >
    <template #header-icon>
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="17" viewBox="0 0 28 17" fill="none">
        <path d="M14 17C13.1133 17 12.2558 16.876 11.4275 16.6281C10.5992 16.3802 9.835 16.0201 9.135 15.5479C8.10833 15.4771 7.05833 15.2528 5.985 14.875C4.91167 14.4972 3.93167 13.8715 3.045 12.9979C2.15833 12.1243 1.42917 10.9792 0.8575 9.5625C0.285833 8.14583 0 6.375 0 4.25V3.54167C0 2.55 0.338333 1.71181 1.015 1.02708C1.69167 0.342361 2.52 0 3.5 0C4.41 0 5.1975 0.31875 5.8625 0.95625C6.5275 1.59375 6.895 2.36111 6.965 3.25833C7.61833 3.06944 8.20167 2.83333 8.715 2.55C9.22833 2.26667 9.75333 1.99514 10.29 1.73542C10.8267 1.45208 11.3867 1.21007 11.97 1.00937C12.5533 0.808681 13.23 0.708333 14 0.708333C14.7933 0.708333 15.4758 0.808681 16.0475 1.00937C16.6192 1.21007 17.1733 1.45208 17.71 1.73542C18.2233 1.99514 18.7425 2.26667 19.2675 2.55C19.7925 2.83333 20.3817 3.06944 21.035 3.25833C21.105 2.3375 21.4725 1.56424 22.1375 0.938542C22.8025 0.312847 23.59 0 24.5 0C25.48 0 26.3083 0.342361 26.985 1.02708C27.6617 1.71181 28 2.55 28 3.54167V4.25C28 6.375 27.7142 8.14583 27.1425 9.5625C26.5708 10.9792 25.8417 12.1243 24.955 12.9979C24.0683 13.8715 23.0883 14.4972 22.015 14.875C20.9417 15.2528 19.8917 15.4771 18.865 15.5479C18.165 16.0201 17.4008 16.3802 16.5725 16.6281C15.7442 16.876 14.8867 17 14 17ZM6.3 12.7146C5.85667 12.0063 5.5125 11.233 5.2675 10.3948C5.0225 9.5566 4.9 8.68889 4.9 7.79167V3.54167C4.9 3.14028 4.76583 2.80382 4.4975 2.53229C4.22917 2.26076 3.89667 2.125 3.5 2.125C3.10333 2.125 2.77083 2.26076 2.5025 2.53229C2.23417 2.80382 2.1 3.14028 2.1 3.54167V4.25C2.1 6.84722 2.53167 8.78333 3.395 10.0583C4.25833 11.3333 5.22667 12.2188 6.3 12.7146ZM14 14.875C15.9367 14.875 17.5875 14.1844 18.9525 12.8031C20.3175 11.4219 21 9.75139 21 7.79167V5.45417C20.2067 5.26528 19.5125 5.04097 18.9175 4.78125C18.3225 4.52153 17.78 4.23819 17.29 3.93125C16.6367 3.52986 16.0592 3.24653 15.5575 3.08125C15.0558 2.91597 14.5367 2.83333 14 2.83333C13.4633 2.83333 12.9442 2.91597 12.4425 3.08125C11.9408 3.24653 11.3633 3.52986 10.71 3.93125C10.22 4.21458 9.6775 4.49792 9.0825 4.78125C8.4875 5.06458 7.79333 5.28889 7 5.45417V7.79167C7 9.75139 7.6825 11.4219 9.0475 12.8031C10.4125 14.1844 12.0633 14.875 14 14.875ZM9.8 7.4375C10.3133 7.29583 10.7567 7.12465 11.13 6.92396C11.5033 6.72326 11.8533 6.52847 12.18 6.33958C12.5067 6.15069 12.8042 5.99132 13.0725 5.86146C13.3408 5.7316 13.65 5.66667 14 5.66667C14.35 5.66667 14.6592 5.7316 14.9275 5.86146C15.1958 5.99132 15.4933 6.15069 15.82 6.33958C16.1467 6.52847 16.4908 6.72326 16.8525 6.92396C17.2142 7.12465 17.6633 7.29583 18.2 7.4375V5.95C17.85 5.83194 17.5467 5.70208 17.29 5.56042L16.52 5.13542C16.1467 4.89931 15.7675 4.69271 15.3825 4.51562C14.9975 4.33854 14.5367 4.25 14 4.25C13.4633 4.25 13.0025 4.33854 12.6175 4.51562C12.2325 4.69271 11.8417 4.89931 11.445 5.13542L10.675 5.56042C10.4183 5.70208 10.1267 5.83194 9.8 5.95V7.4375ZM21.7 12.7146C22.7733 12.2188 23.7417 11.3333 24.605 10.0583C25.4683 8.78333 25.9 6.84722 25.9 4.25V3.54167C25.9 3.14028 25.7658 2.80382 25.4975 2.53229C25.2292 2.26076 24.8967 2.125 24.5 2.125C24.1033 2.125 23.7708 2.26076 23.5025 2.53229C23.2342 2.80382 23.1 3.14028 23.1 3.54167V7.79167C23.1 8.68889 22.9833 9.5566 22.75 10.3948C22.5167 11.233 22.1667 12.0063 21.7 12.7146Z" fill="white"/>
      </svg>
    </template>

    <!-- Allergy Count Row -->
    <div class="allergy-count-row">
      <span class="allergy-count-text">{{ filteredAllergies.length }} existing allergies</span>
    </div>

    <!-- Search and Filter Row -->
    <div class="search-filter-row">
      <div class="search-section">
        <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M14.2939 12.5786H13.3905L13.0703 12.2699C14.191 10.9663 14.8656 9.27387 14.8656 7.43282C14.8656 3.32762 11.538 0 7.43282 0C3.32762 0 0 3.32762 0 7.43282C0 11.538 3.32762 14.8656 7.43282 14.8656C9.27387 14.8656 10.9663 14.191 12.2699 13.0703L12.5786 13.3905V14.2939L18.2962 20L20 18.2962L14.2939 12.5786ZM7.43282 12.5786C4.58548 12.5786 2.28702 10.2802 2.28702 7.43282C2.28702 4.58548 4.58548 2.28702 7.43282 2.28702C10.2802 2.28702 12.5786 4.58548 12.5786 7.43282C12.5786 10.2802 10.2802 12.5786 7.43282 12.5786Z" fill="#374957"/>
        </svg>
        <TextInput
          v-model="searchQuery"
          size="medium"
          :clearable="false"
          placeholder="Search Allergen"
          class="allergy-form-select"
        />
      </div>
      <ResponsiveButton
        display_name="Add New"
        button_type="filled"
        built_in_theme="dark"
        size="medium"
        button_border_radius="20px"
        customized_class="add-new-foldable-btn"
        @click-button="handleAddNew"
      />
    </div>

    <!-- Dashed Line -->
    <div class="dashed-line"></div>

    <!-- Allergies List -->
    <div class="allergies-list">
      <div
        v-for="allergy in paginatedAllergies"
        :key="allergy.id"
        class="allergy-list-item"
      >
        <div class="allergy-info">
          <p class="allergy-name">{{ allergy.allergen }}</p>
          <p v-if="allergy.reactions" class="allergy-reactions">
            Reactions: {{ allergy.reactions }}
          </p>
        </div>
        <div class="allergy-actions">
          <button class="edit-btn" @click="handleEdit(allergy)">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M21.4555 5.41575C21.6477 5.70687 21.6157 6.10248 21.3594 6.35876L12.167 15.5511C12.0728 15.6454 11.9552 15.7128 11.8263 15.7465L7.99783 16.7465C7.87296 16.7791 7.74425 16.7784 7.62332 16.7476C7.49475 16.7149 7.37498 16.6482 7.27797 16.5511C7.08969 16.3629 7.01535 16.0889 7.08264 15.8313L8.08264 12.0028C8.11211 11.89 8.1674 11.7786 8.24389 11.6912L17.4703 2.46967C17.5511 2.38891 17.6484 2.32846 17.7543 2.29163C17.8328 2.26432 17.916 2.25 18.0007 2.25C18.1996 2.25 18.3903 2.32902 18.531 2.46967L21.3594 5.2981C21.396 5.33471 21.4281 5.37416 21.4555 5.41575ZM19.7684 5.82843L18.0007 4.06066L9.48251 12.5788L8.85752 14.9716L11.2503 14.3466L19.7684 5.82843Z" fill="#374957"/>
              <path d="M19.642 17.1603C19.9154 14.8227 20.0024 12.4688 19.903 10.1208C19.8982 10.0084 19.9405 9.89898 20.0201 9.81942L21.0034 8.83609C21.1243 8.71519 21.3309 8.79194 21.3422 8.96254C21.5271 11.7522 21.457 14.5545 21.1319 17.3346C20.8953 19.3571 19.271 20.9421 17.2589 21.167C13.7924 21.5544 10.209 21.5544 6.74244 21.167C4.73038 20.9421 3.10605 19.3571 2.8695 17.3346C2.45496 13.7903 2.45496 10.2097 2.8695 6.66543C3.10605 4.6429 4.73038 3.05789 6.74244 2.83301C9.37219 2.5391 12.0691 2.46815 14.7313 2.62016C14.9029 2.62996 14.9811 2.83757 14.8596 2.95909L13.867 3.95165C13.7883 4.03034 13.6804 4.07261 13.5692 4.06885C11.3428 3.99376 9.10122 4.07872 6.90905 4.32373C5.57894 4.47239 4.51346 5.522 4.35934 6.83968C3.95834 10.2682 3.95834 13.7318 4.35934 17.1603C4.51346 18.478 5.57894 19.5276 6.90905 19.6763C10.2649 20.0513 13.7365 20.0513 17.0923 19.6763C18.4224 19.5276 19.4879 18.478 19.642 17.1603Z" fill="#374957"/>
            </svg>
          </button>
          <button class="delete-btn" @click="handleDelete(allergy)">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0V1H16V3H15V16C15 17.1 14.1 18 13 18H3C1.9 18 1 17.1 1 16V3H0V1H5V0H11ZM3 16H13V3H3V16ZM5 5H7V14H5V5ZM11 5H9V14H11V5Z" fill="#D10000"/>
            </svg>
          </button>
        </div>
      </div>
      <div v-if="paginatedAllergies.length === 0" class="empty-state">
        <p>No allergies found</p>
      </div>
    </div>

    <!-- Pagination -->
    <div class="pagination-wrapper">
      <Pagination
        :total_items="filteredAllergies.length"
        :current_page="currentPage"
        :per_page="pageSize"
        :per_page_options="[5, 10, 15]"
        item_label="allergies"
        @update:current_page="handlePageChange"
        @update:per_page="handlePageSizeChange"
      />
    </div>
  </Dialog>
</template>

<script>
import { deleteAllergyRecord } from '@/api/medicationApi';
import { notify } from '@/utils/notify';

export default {
  name: 'AllergiesListDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    allergies: {
      type: Array,
      default: () => []
    },
    patientId: {
      type: String,
      default: ''
    }
  },
  emits: ['close', 'add-new', 'edit', 'deleted'],
  data() {
    return {
      searchQuery: '',
      currentPage: 1,
      pageSize: 5,
      localAllergies: []
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('close');
        }
      }
    },
    filteredAllergies() {
      let filtered = [...this.localAllergies];

      // Filter by search query
      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase();
        filtered = filtered.filter(allergy =>
          allergy.allergen?.toLowerCase().includes(query) ||
          allergy.reactions?.toLowerCase().includes(query)
        );
      }

      return filtered;
    },
    paginatedAllergies() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.filteredAllergies.slice(start, end);
    }
  },
  watch: {
    allergies: {
      immediate: true,
      handler(newVal) {
        this.localAllergies = [...(newVal || [])];
      }
    },
    visible(newVal) {
      if (newVal) {
        this.localAllergies = [...(this.allergies || [])];
        this.searchQuery = '';
        this.currentPage = 1;
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit('close');
    },
    handleAddNew() {
      this.$emit('add-new');
    },
    handleEdit(allergy) {
      this.$emit('edit', allergy);
    },
    async handleDelete(allergy) {
      if (!this.patientId) {
        notify({
          title: 'Error',
          message: 'Patient ID is required',
          type: 'error',
          duration: 3000
        });
        return;
      }

      try {
        await deleteAllergyRecord(this.patientId, allergy.id);

        // Remove from local list
        const index = this.localAllergies.findIndex(a => a.id === allergy.id);
        if (index > -1) {
          this.localAllergies.splice(index, 1);
        }

        // Emit deleted event to parent
        this.$emit('deleted', allergy.id);

        notify({
          title: 'Success',
          message: 'Allergy Deleted Successfully',
          type: 'success',
          duration: 3000
        });
      } catch (error) {
        console.error('Failed to delete allergy:', error);
        notify({
          title: 'Error',
          message: 'Failed to Delete Allergy',
          type: 'error',
          duration: 3000
        });
      }
    },
    handlePageChange(page) {
      this.currentPage = page;
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
    }
  }
};
</script>

<style scoped>
.allergy-count-row {
  padding: 24px 24px 0;
  margin-bottom: 12px;
}

.search-filter-row {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px 16px;
}

.search-section {
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-icon {
  flex-shrink: 0;
}

.allergy-form-select {
  width: 200px;
}

:deep(.allergy-form-select .el-input__wrapper) {
  border: 1px solid #C4C4C4 !important;
  box-shadow: none !important;
  height: 40px !important;
  border-radius: 4px !important;
  background-color: #fff !important;
}

:deep(.allergy-form-select .el-input__wrapper:hover),
:deep(.allergy-form-select .el-input__wrapper.is-focus) {
  border: 1px solid #C4C4C4 !important;
  box-shadow: none !important;
}

:deep(.allergy-form-select .el-input__inner::placeholder) {
  font-size: 14px !important;
  color: #999 !important;
}

.allergy-count-text {
  color: #333;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0.4px;
}

.pagination-wrapper {
  padding: 12px 24px 16px;
}

:deep(.add-new-foldable-btn) {
  flex-shrink: 0;
  white-space: nowrap;
}

.dashed-line {
  border-top: 1px dashed #C4C4C4;
  margin: 0 24px 16px;
}

.allergies-list {
  min-height: 350px;
  max-height: 450px;
  overflow-y: auto;
  padding: 0 24px;
}

.allergies-list::-webkit-scrollbar {
  width: 6px;
}

.allergies-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.allergies-list::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 3px;
}

.allergies-list::-webkit-scrollbar-thumb:hover {
  background: #999;
}

.allergy-list-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  border-bottom: 1px solid #E5E5E5;
  transition: background-color 0.2s;
}

.allergy-list-item:last-child {
  border-bottom: none;
}

.allergy-info {
  flex: 1;
}

.allergy-name {
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin: 0 0 4px 0;
  line-height: 20px;
}

.allergy-reactions {
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: var(--SecondaryBlack, #666);
  margin: 0;
}

.allergy-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.edit-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.edit-btn:hover {
  background-color: rgba(55, 73, 87, 0.1);
}

.delete-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.delete-btn:hover {
  background-color: #FEEBEB;
}

.empty-state {
  padding: 40px 20px;
  text-align: center;
  color: #999;
  font-style: italic;
}
</style>
